import { endpoints } from '../constants/endpoints';
import { sendRequest } from './sendRequest';

export const uploadProfilePhotoApi = (fileObject, employeeId) => {
  const url = endpoints.employee.profileImageUpload(employeeId);
  const data = new FormData();
  data.append('attachment', fileObject);
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: data,
    isMultiPart: true,
  });
};

// TODO: figure out what all to do in then and catch
export const deleteProfilePicApi = (employeeId) => {
  const url = endpoints.employee.deleteProfileImage(employeeId);

  return fetch(url, {
    method: 'DELETE',
    credentials: 'include',
  }).then((res) => {
    if (res.ok) {
      return res.json();
    }
    throw new Error('Something went wrong');
  });
};

export const checkIfEmployeeIsManagerOfManagerApi = (loggedInEmployeeId, employeeId) => {
  const url = endpoints.employee.checkIfEmployeeIsManagerOfManager(loggedInEmployeeId);

  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: { empId: employeeId },
  });
};

export const employeeDetailsApi = (employeeId) => {
  const url = endpoints.employee.details(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getNodesApi = ({ employeeId, limit = 8, offset = 0 }) => {
  const url = endpoints.employee.nodes(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: { limit, offset },
  });
};

export const getRelationshipsApi = ({ employeeId, limit = 8, offset = 0 }) => {
  const url = endpoints.employee.relationships;
  const body = {
    employee: {
      id: employeeId,
    },
    limit,
    offset,
  };
  return sendRequest({
    url,
    method: 'POST',
    body,
  });
};

export const getLeaderboardApi = ({ trophyId, limit = 3 }) => {
  const url = endpoints.employee.leaderboard(trophyId);

  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: { limit },
  });
};

export const getLeaderboardTrophiesApi = ({ teamId }) => {
  const url = endpoints.employee.leaderboardTrophies;
  const queryParams = { teamId };
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams,
  });
};

export function nominateForTrophyApi({ trophyId, employeeId, limit = 3 }) {
  const url = endpoints.employee.nominate;
  const type = 'NOMINATE';
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      type,
      employeeId,
      trophyId,
      limit,
    },
  });
}

export const loginApi = ({ email, password, authToken }) => {
  const url = endpoints.employee.login;
  const body =
    email && password
      ? {
          orgId: '1001_1',
          email,
          password,
        }
      : null;
  return sendRequest({
    url,
    method: 'POST',
    body,
    credentials: 'include',
  });
};

export function authenticateApi({ landingPageType, landingPageUuid, teamType = null }) {
  const url = endpoints.employee.login;
  const types = ['EMPLOYEE', 'TEAM'];
  const body =
    landingPageType && landingPageUuid
      ? {
          landingPageType,
          landingPageUuid,
          ...(teamType && { cohortType: teamType }),
        }
      : null;
  return sendRequest({
    url,
    method: 'POST',
    body,
    credentials: 'include',
  });
}

export function authenticateNetchexApi({ jwtToken }) {
  const url = endpoints.employee.loginNetchex;

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  });
}

export function verifyNetchexNotificationApi({ internalEmpId, netchexRole }) {
  const url = endpoints.employee.netchexNotificationLinkVerify;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      internalEmpId,
      role: netchexRole,
    },
  });
}

export function authenticateDemoUserApi({ demoUserEmail }) {
  const url = endpoints.demo.demoUserLogin;
  const body = {
    email: demoUserEmail,
  };

  return sendRequest({
    url,
    method: 'POST',
    body,
    credentials: 'include',
  });
}

export const logoutApi = () => {
  const url = endpoints.employee.logout;

  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export function getMeshTrophiesApi(employeeId) {
  const url = endpoints.employee.meshTrophies(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
}

export function employeeReliabilityScoreApi({ employeeId }) {
  const url = endpoints.employee.reliabilityScore(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
}

export const getEmployeeTeamsApi = ({ employeeId }) => {
  const url = endpoints.employee.teams(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

/* 
Search employees based on first and last name. If text is empty will return all employees,
subject to offset and limit.
*/
export const searchEmployees = ({ text, tagType = 'EMPLOYEE_NAME_AND_EMAIL', limit = 5, offset = 0 }) => {
  const url = endpoints.employee.search;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: { text, tagType, limit, offset },
  });
};

/** Create employee. Being referenced by admin api service */
export const addNewEmployeeApi = (employee, sendEmail = true) => {
  const url = endpoints.employee.create;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: { ...employee },
    queryParams: { sendEmail, viaUI: true },
  });
};

export const removeEmployeeApi = ({ employeeId }) => {
  const url = endpoints.employee.remove(employeeId);
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
    queryParams: {
      isSync: false, // <- this will always be false from UI
    },
  });
};

export const setUserTimeZoneApi = ({ employeeId, timezone }) => {
  const url = endpoints.employee.timezone(employeeId);
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: { timezone },
  });
};
